import { memo } from 'react'
import './LoadingScreen.css'

/**
 * Premium loading screen with mystical golden spiral animation
 * Displays while R3F canvas is initializing
 *
 * @param {Object} props
 * @param {boolean} props.isLoading - Controls visibility of loading screen
 */
function LoadingScreen({ isLoading = true }) {
  return (
    <div className={`loading-screen ${!isLoading ? 'fade-out' : ''}`}>
      {/* Floating particles for ambient effect */}
      <div className="loading-particles">
        <div className="particle" />
        <div className="particle" />
        <div className="particle" />
        <div className="particle" />
        <div className="particle" />
        <div className="particle" />
        <div className="particle" />
        <div className="particle" />
      </div>

      {/* Animated golden spiral */}
      <div className="loading-spiral">
        <div className="spiral-ring" />
        <div className="spiral-ring" />
        <div className="spiral-ring" />
        <div className="spiral-ring" />
        <div className="spiral-ring" />
        <div className="spiral-ring" />
        <div className="spiral-center" />
      </div>

      {/* Loading text */}
      <div className="loading-text">
        Loading<span className="loading-dots" />
      </div>
    </div>
  )
}

export default memo(LoadingScreen)
